window.onload = function() {
    // Handle recently-tryon-pdp elements
    var productRecently = document.querySelectorAll(".recently-tryon-pdp");

    if (productRecently.length > 0) {
        productRecently.forEach(function(productRecentlyView) {
            var tryonButtonRecent = productRecentlyView.querySelector(".tryonButton2");
            var trendingBadgeRecent = productRecentlyView.querySelector("span.badge.trending-item");

            if (tryonButtonRecent && trendingBadgeRecent) {
                tryonButtonRecent.style.display = "block"; // Show tryonButton2
                trendingBadgeRecent.style.display = "none"; // Hide trending badge
            }
        });
    } else {
        
    }

    // Handle related-products-pdp elements
    var productRelated = document.querySelectorAll(".related-products-pdp");

    if (productRelated.length > 0) {
        productRelated.forEach(function(productRelatedPro) {
            var tryonButtonRelated = productRelatedPro.querySelector(".tryonButton2");
            var trendingBadgeRelated = productRelatedPro.querySelector("span.badge.trending-item");

            if (tryonButtonRelated && trendingBadgeRelated) {
                tryonButtonRelated.style.display = "block"; // Show tryonButton2
                trendingBadgeRelated.style.display = "none"; // Hide trending badge
            }
        });
    } else {
        
    }
};

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);



